import { Component, Input, OnInit } from '@angular/core';
import { EChartsOption } from 'echarts';

@Component({
  selector: 'app-dashboard-graph',
  templateUrl: './dashboard-graph.component.html',
  styleUrls: ['./dashboard-graph.component.scss'],
})
export class DashboardGraphComponent implements OnInit {
  @Input() line: any;
  constructor() {}
  resSample: any = [
    {
      verified: 162,
      unverified: 57,
      tick: 'All Time',
    },
  ];
  resData2 = [{}];
  ngOnInit(): void {
    this.format(this.resSample);
  }

  format(data) {
    function groupBy(objectArray, property) {
      return objectArray.reduce(function (acc, obj) {
        var key = obj[property];
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(obj);
        return acc;
      }, {});
    }
    let groupObject = groupBy(data, 'tick');
    let convertToArr = Object.keys(groupObject).map((key) => {
      return { status: key, users: groupObject[key] };
    });
    this.generateLine(convertToArr);
  }

  generateLine(datas) {
    let type = ['tick', 'verified', 'unverified'];
    let dataSource: Array<any> = [type];
    datas.forEach((res) => {
      let arr = [];
      res.users.forEach((res) => {
        arr.push(res.tick);
        arr.push(res.verified);
        arr.push(res.unverified);
        dataSource.push(arr);
      });
    });
    let chartOptionx = {
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      legend: {
        data: ['barA', 'barB'],
        align: 'left',
      },
      dataset: {
        source: [...dataSource],
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true,
      },
      xAxis: { type: 'category' },
      yAxis: {},
      series: [
        {
          type: 'bar',
          stack: 'tick',

          color: ['#36397F'],
        },
        {
          type: 'bar',
          stack: 'tick',
          color: ['#4BBEFF'],
        },
      ],
    };
    this.line = chartOptionx;
    console.log('reach ', this.line);
  }

  initOpts = {
    renderer: 'svg',
    width: 300,
    height: 300,
  };

  options2: EChartsOption = {
    color: ['#3398DB'],
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    },
    xAxis: [
      {
        type: 'category',
        data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        axisTick: {
          alignWithLabel: true,
        },
      },
    ],
    yAxis: [
      {
        type: 'value',
      },
    ],
    series: [
      {
        name: 'Counters',
        type: 'bar',
        barWidth: '60%',
        data: [10, 52, 200, 334, 390, 330, 220],
      },
    ],
  };
}
